import React from "react"
import '../../styles/tours/tour-schedule.scss'
import ShowMore from "react-show-more"

const TourSchedule = () => {
  const schedule = [
    {
      title: 'Πτήση από την Ελλάδα για το Μπαλί',
      text: 'Πρωινή συγκέντρωση στο αεροδρόμιο Ελ. Βενιζέλος στην Αθήνα. Στις 11.30 αναχωρούμε μέσω Σιγκαπούρη για το νησί των Θεών.'
    },
    {
      title: 'Μπαλί',
      text: 'Άφιξη στο Μπαλί στις 09.50. Μετά τις διατυπώσεις και την παραλαβή των αποσκευών μας, συνάντηση με τον τοπικό μας ξεναγό. Κατά τη διάρκεια της μεταφοράς σας στο ξενοδοχείο θα λάβετε τις αρχικές βασικές πληροφορίες για το νησί και τις καθημερινές δραστηριότητες. Τακτοποίηση στο δωμάτιο και χρόνος ελεύθερος για ξεκούραση ή μπάνιο στον Ινδικό ωκεανό. Το απόγευμα σας προτείνουμε βόλτα στην παραλία Seminyak για να απολαύσετε υπέροχο ηλιοβασίλεμα από το lounge bar Ku.De.Ta ή να χαλαρώσετε με το πρώτο σας Μπαλινέζικο μασάζ.',
    },
    {
      title: 'Εκδρομή στο Κεντρικό & Βόρειο Μπαλί & Ναός Tanah Lot',
      text: 'Αναχώρηση στις 08.30 από το ξενοδοχείο και επίσκεψη του σημαντικότερου αξιοθέατου του νησιού, του εμβληματικού ναού Tanah Lot, χτισμένου πάνω σε βράχο μέσα στον Ινδικό ωκεανό. Επόμενη στάση ο ναός Taman Ayun, βασιλικός ναός της δυναστείας Mengwi, περιτριγυρισμένος από λίμνη και επιβλητικούς κήπους. Στη διαδρομή θα απολαύσετε τους περίφημους ορυζώνες του νησιού και μαγικά χωριά. Συνεχίζουμε για την παραδοσιακή αγορά Candi Kuning, όπου μπορείτε να βρείτε φρέσκα φρούτα, λαχανικά, καφέ, μπαχαρικά και βότανα, και εξωτικά λουλούδια, όπως οι ορχιδέες και τα τοπικά τριαντάφυλλα. Η εκδρομή μας συνεχίζει με το μαγευτικό Ινδουιστικό ναό Ulun Danu. Ο ναός είναι χτισμένος δίπλα στην υπέροχη λίμνη Beratan. Η τοποθεσία είναι ανεπανάληπτη, καθώς γύρω της βρίσκονται τέσσερα βουνά, δημιουργώντας μία εκπληκτική ατμόσφαιρα και εικόνα. Στόχος: Η εκδρομή θα σας μυήσει στον πολιτισμό του Μπαλί, με επίσκεψη σε μερικούς από τους κορυφαίους ναούς του νησιού. Επίσης θα μάθετε περισσότερα πράγματα για το μυστικό κόσμο των μπαχαριών. Εύκολη εκδρομή με μεγαλύτερες χρονικά μεταφορές. Διάρκεια: 9-10 ώρες, Μεταφορά με deluxe κλιματιζόμενο όχημα, Περιλαμβάνεται μπουκαλάκι νερού και υπηρεσία τοπικού ξεναγού, Δεν περιλαμβάνεται γεύμα'
    },
    {
      title: 'Μπαλί - Ελευθερες μερες',
      text: 'Ελεύθερες ημέρες για να απολαύσουμε τις νότιες ακτές, τον κοραλλιογενή βυθό και την κοσμοπολίτικη νυχτερινή ζωή. Σας προτείνουμε εναλλακτικά εξαιρετικές δραστηριότητες φύσης, πολιτισμού και αδρεναλίνης.'
    },
    {
      title: 'Τσιάνγκ Μάι – Μπανγκόκ, ξενάγηση της πόλης',
      text: 'Νωρίς το πρωί θα μεταφερθούμε στο αεροδρόμιο και θα πετάξουμε για τη Μπανγκόκ, την πρωτεύουσα της χώρας. Άφιξη και συνάντηση με τον τοπικό μας ξεναγό. Ξεκινάμε απευθείας με την περιήγηση της «Βενετίας της Ανατολής», όπως αποκαλείται, λόγω των πολυάριθμων διωρύγων και καναλιών, που τη διατέμνουν. Ξεκινάμε με βαρκάδα κατά μήκος του ποταμού Τσάο Πράγια με τα αμέτρητα κανάλια ή αλλιώς κλονγκς, απ’ όπου θα έχουμε μοναδική θέα του Βασιλικού παλατιού. Πρώτη στάση ο περίφημος Ναό της Αυγής, που είναι καλυμμένος με κομμάτια κινέζικης πορσελάνης και δεσπόζει θεαματικά στο ποτάμι. Στη συνέχεια θα επισκεφθούμε στην αντίπερα όχθη, το ναό του ξαπλωμένου Βούδα (Wat Po), όπου θα έχουμε την ευκαιρία να δούμε ένα από τα πιο εντυπωσιακά αγάλματα του Βούδα σε κεκλιμένη στάση. Ο ναός αυτός αποτελεί επίσης την παλαιότερη και πιο έγκριτη σχολή Ταϊλανδέζικου μασάζ στη χώρα. Συνεχίσουμε την περιήγηση στην περιοχή Πρατούναμ και την τοπική αγορά, ενώ θα απολαύσουμε την μοναδική ατμόσφαιρα με τους παραδοσιακούς  μικροπωλητές των υπαίθριων αγορών της πρωτεύουσας. Μεταφορά στο ξενοδοχείο μας και ξεκούραση. Το βράδυ επισκεφθείτε κάποια από τις πολλές υπαίθριες αγορές της μεγαλούπολης ή ένα από τα κοσμοπολίτικα skyview bars με θέα τους ουρανοξύστες της Μπανγκόκ.'
    }
  ]

  return (
    <section className='bg-light-2 p-4 p-lg-5 my-6'>
      <div className="col-12 offset-0 col-lg-8 offset-lg-2 p-0 p-lg-1">
        <h3 className='display-5 text-normal mb-0'>Αναλυτικο προγραμμα ταξιδιου</h3>
        <h4 className='display-7 text-normal p-0 m-0'>Συνοψη της εκδρομης καθημερινα</h4>
        <div className="list-wrapper mt-5">
          <div className="blue-line"></div>
          {
            schedule.map((day, i)=>{
              return (
                <div className="list-item-wrapper">
                  <div className="list-bullet">{i + 1}</div>
                  <div className="list-item">
                    <div className="list-title">{day.title}</div>
                    <div className="list-text w-100">
                      <article className={'text-secondary w-100'}>
                        <ShowMore
                          lines={5}
                          more='Διαβάστε περισσότερα'
                          less='Απόκρυψη'
                          anchorClass='app-show-more'
                        >
                          {day.text}
                        </ShowMore>
                      </article>
                    </div>
                  </div>
                </div>
              )
            })
          }
        </div>
      </div>
    </section>
  )
}

export default TourSchedule